export type WhatsAppInboxChatKind = 'group' | 'dm';

const GROUP_SUFFIX = '@g.us';

export function isWhatsAppGroupChat(chatId: string): boolean {
  return chatId.endsWith(GROUP_SUFFIX);
}

export function resolveWhatsAppInboxChatKind(chatId: string): WhatsAppInboxChatKind {
  return isWhatsAppGroupChat(chatId) ? 'group' : 'dm';
}
